import { aiChatThreadListOptions } from "@/lib/data/react-query/ai-chat";
import { chatApi } from "@/lib/data/requests/ai-chat";
import type { AiChatThreadStatus, ChatApi } from "@/lib/types/ai-chat";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useAiChatThreads = ({
  api = chatApi,
  status,
}: {
  api?: ChatApi;
  status?: AiChatThreadStatus;
} = {}) => {
  const query = useInfiniteQuery(aiChatThreadListOptions({ api, status }));
  const threads = useMemo(
    () => query.data?.pages.flatMap((page) => page.threads) ?? [],
    [query.data?.pages],
  );
  return {
    ...query,
    threads,
    loadMore: query.fetchNextPage,
  };
};
